import { useEffect } from 'react';
import { compose } from '@reduxjs/toolkit';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import withRole from 'hoc/withRole';
import Error from 'core/errors/Error';
import Button from 'core/buttons/Button';
import withAppState from 'hoc/withAppState';
import PageContent from 'layouts/PageContent';
import CustomerKyc from 'components/customer-kycs/CustomerKyc';

import acl from 'app/config/acl';
import { buildRoute } from 'routes';
import { resetGetCustomerKycFailure } from 'app/features/customer-kycs/customerKycSlice';
import NewPageContent from 'layouts/NewPageContent';
import routePaths from 'app/config/routePaths';

function ViewCustomerKyc({ isNetworkError }) {
  const params = useParams();

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const { isError, errorCode, errorMessage } = useSelector((state) => state.customerKycs.show);

  useEffect(() => {
    if (isError) dispatch(resetGetCustomerKycFailure());
  }, [isNetworkError]);

  if (isError)
    return (
      <Error
        status={errorCode}
        message={errorMessage}
        onRetry={() => dispatch(resetGetCustomerKycFailure())}
      />
    );

  return (
    <NewPageContent
      breadcrumbs={[
        { label: 'Customer KYC', to: routePaths.ListCUstomerKyc },
        { label: 'Customer KYC Details', to: '' },
      ]}
      documentTitle="Customer Kyc Details"
    >
      <CustomerKyc customerKycId={params.customerKycId} />
    </NewPageContent>
  );
}

export default compose(
  withAppState,
  withRole([acl.SUPERADMIN, acl.ADMIN, acl.USER]),
)(ViewCustomerKyc);
